import React, { useContext, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from 'features/auth/context/Auth';
import Loader from 'features/Loader/Loader';
import { connect } from 'react-redux';
import { CLEAR_ACTIVE_CHANNEL_STATE } from 'features/messages/components/ducks/types';

const NoUserRoute = ({
  component: RouteComponent,
  clearActiveChannelState,
  userProcessLoading,
  ...rest
}) => {
  const { currentUser, isLoading } = useContext(AuthContext);

  useEffect(() => {
    clearActiveChannelState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Route
      {...rest}
      render={routeProps => {
        if (isLoading) return <Loader />;
        if (!currentUser || userProcessLoading || !currentUser.emailVerified) {
          return <RouteComponent {...routeProps} />;
        } else return <Redirect to={'/'} />;
      }}
    />
  );
};

function mapStateToProps(state) {
  return {
    userProcessLoading: state.authReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearActiveChannelState: () =>
      dispatch({
        type: CLEAR_ACTIVE_CHANNEL_STATE
      })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NoUserRoute);
